import { SystemRoleName } from '@evimo/types/enums/system-role-name';
import { useAuth } from '~/app/auth/context/AuthContext';
import { SupervisorDashboard } from '~/app/dashboard/components/SupervisorDashboard';
import { OrganizationManagerDashboardPageContainer } from '~/app/landing/dashboard/organization-manager/OrganizationManagerDashboardPageContainer';

export function HomeScreen() {
  const { user } = useAuth();

  if (user?.roleName === SystemRoleName.ORGANIZATION_MANAGER) {
    return <OrganizationManagerDashboardPageContainer />;
  }

  return <SupervisorDashboard />;
}
